import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitPipe'
})
export class SplitPipeStringPipe implements PipeTransform {
    transform(val: string): string[] {
        return val.split('|');
    }
}